import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface PaymentFailureModalProps {
  open: boolean;
  onClose: () => void;
  onSwitchToFree: () => void;
  onRetryPayment: () => void;
  errorMessage?: string;
}

export const PaymentFailureModal: React.FC<PaymentFailureModalProps> = ({
  open,
  onClose,
  onSwitchToFree,
  onRetryPayment,
  errorMessage = "Payment processing failed. Please try again."
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
          Payment Failed
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {errorMessage}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Would you like to continue with a <strong>Free membership plan</strong> instead? 
            You can always upgrade your plan later from your dashboard.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            With the free plan, you'll still have access to basic features and can upgrade anytime.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 2 }}>
        <Button 
          onClick={onRetryPayment} 
          variant="outlined" 
          sx={{ minWidth: 120 }}
        >
          Retry Payment
        </Button>
        <Button
          onClick={onSwitchToFree}
          variant="contained"
          sx={{
            backgroundColor: '#d22268',
            '&:hover': { backgroundColor: '#b01c5a' },
            minWidth: 140,
          }}
        >
          Continue with Free Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};